import * as React from 'react'
import { useState } from 'react'
import { Loader } from '../../kit/components/loader'
import { useRouteMatch } from 'react-router'
import { Auth, Hub } from 'aws-amplify'
import { useMount } from 'react-use'
import { HubRedirectUrlData } from '../../utils/hub-utils'

interface LoginWithTokenRegisterParams {
  organizationId: string
  token: string
  opportunityId: string
}

export function LoginWithTokenRegister(props: any) {
  const [loading, setLoading] = useState<boolean>(true)

  const { params } = useRouteMatch<LoginWithTokenRegisterParams>()
  const { organizationId, token, opportunityId } = params

  useMount(async () => {
    if (token && organizationId && opportunityId) {
      localStorage.setItem('schedulerToken', token)
      await Auth.signOut()
      const data = new HubRedirectUrlData(
        `/organizations/${organizationId}/opportunities/${opportunityId}/event-registration`,
      )
      Hub.dispatch('auth', { event: 'signIn', data })
      setLoading(false)
    } else {
      setLoading(false)
    }
  })

  if (loading) {
    return <Loader />
  }

  return <div>There was an error parsing your token. Please return to the app and try again</div>
}
